import { render } from "./activity.vue?vue&type=template&id=09a28ff4"
const script = {}

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__